(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ll-dutch-presale-announcement"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.dutch-presale-layout [data-countdown]').forEach((timer) => {
    const target = new Date(timer.dataset.countdown).getTime();
    if (!Number.isFinite(target)) return;
    const tick = () => {
      const remaining = Math.max(0, target - Date.now());
      const hours = Math.floor(remaining / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      timer.querySelector('[data-hours]').textContent = String(hours).padStart(2, '0');
      timer.querySelector('[data-minutes]').textContent = String(minutes).padStart(2, '0');
      timer.querySelector('[data-seconds]').textContent = String(seconds).padStart(2, '0');
    };
    tick();
    window.setInterval(tick, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-dutch-presale-reviews"] && !Shopify.designMode) return;
  try {
    
  const marqueeStates = new WeakMap();

  function setupReviewMarquee(section) {
    if (!section || marqueeStates.has(section)) return;
    const track = section.querySelector('.ll-dutch-reviews__track');
    const firstGroup = section.querySelector('.ll-dutch-reviews__group');
    if (!track || !firstGroup || firstGroup.children.length === 0) return;

    const speed = Number(section.dataset.marqueeSpeed) || 48;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame;
    let lastTime = performance.now();
    let paused = false;
    let resumeAt = 0;
    let position = track.scrollLeft;

    const pauseForInteraction = () => { position = track.scrollLeft; resumeAt = performance.now() + 1600; };
    const pause = () => { position = track.scrollLeft; paused = true; };
    const resume = () => { position = track.scrollLeft; paused = false; lastTime = performance.now(); };

    const animate = (time) => {
      const elapsed = Math.min(time - lastTime, 64);
      if (!paused && time >= resumeAt && !document.hidden && !reducedMotion.matches) {
        position += speed * elapsed / 1000;
        const loopWidth = firstGroup.getBoundingClientRect().width;
        if (loopWidth && position >= loopWidth) position -= loopWidth;
        track.scrollLeft = position;
      }
      lastTime = time;
      frame = requestAnimationFrame(animate);
    };

    track.addEventListener('mouseenter', pause);
    track.addEventListener('mouseleave', resume);
    track.addEventListener('pointerdown', pause);
    track.addEventListener('pointerup', () => { paused = false; pauseForInteraction(); });
    track.addEventListener('pointercancel', resume);
    track.addEventListener('wheel', pauseForInteraction, { passive: true });
    track.addEventListener('touchmove', pauseForInteraction, { passive: true });
    frame = requestAnimationFrame(animate);

    marqueeStates.set(section, () => cancelAnimationFrame(frame));
  }

  document.querySelectorAll('[data-ll-dutch-review-marquee]').forEach(setupReviewMarquee);
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-ll-dutch-review-marquee]');
    if (section) setupReviewMarquee(section);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('[data-ll-dutch-review-marquee]');
    const cleanup = section && marqueeStates.get(section);
    if (cleanup) cleanup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ll-dutch-presale-sticky-cart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector('[data-ll-dutch-sticky-cart]');
    const hero = document.querySelector('.ll-dutch-hero');
    const offer = document.querySelector('.ll-dutch-offer');
    if (!bar || !hero) return;
    const update = () => {
      const afterHero = window.scrollY > hero.offsetTop + hero.offsetHeight - 140;
      const atOffer = offer && offer.getBoundingClientRect().top < window.innerHeight * .82;
      bar.classList.toggle('is-active', window.innerWidth <= 991 && afterHero && !atOffer);
    };
    update();
    addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);

    const form = bar.querySelector('[data-ll-dutch-cart-form]');
    if (!form) return;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button');
      const label = form.querySelector('[data-default-label]');
      const status = bar.querySelector('[data-ll-dutch-cart-status]');
      button.disabled = true;
      status.textContent = '';
      try {
        const shopRoot = window.Shopify?.routes?.root || '/';
        const response = await fetch(shopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Cart request failed');
        label.textContent = 'ADDED TO CART';
        status.textContent = 'Moon Magic Mini was added to your cart.';
        setTimeout(() => { window.location.href = shopRoot + 'cart'; }, 650);
      } catch (error) {
        status.textContent = 'Unable to add this item. Please try again.';
        button.disabled = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lois-javvy-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('.ll-javvy[data-section-id]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const mainImage = root.querySelector('.ll-javvy__main-image');
      const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
      let activeIndex = 0;
      const showImage = (index) => {
        if (!mainImage || !thumbs.length) return;
        activeIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[activeIndex];
        mainImage.src = thumb.dataset.image;
        mainImage.srcset = '';
        mainImage.alt = thumb.dataset.alt || '';
        thumbs.forEach((item, itemIndex) => {
          const active = itemIndex === activeIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };
      thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showImage(index)));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(activeIndex - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(activeIndex + 1));

      const variantsNode = root.querySelector('[data-product-json]');
      const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
      const variantInput = root.querySelector('[data-variant-id]');
      const variantSelect = root.querySelector('[data-variant-select]');
      const quantityInput = root.querySelector('[data-quantity-input]');
      const addButton = root.querySelector('[data-add-button]');
      const addLabel = root.querySelector('[data-add-label]');
      const mobilePrice = root.querySelector('[data-mobile-price]');
      const form = root.querySelector('[data-product-form]');
      let quantity = 1;
      let purchaseMode = 'one-time';
      const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
      const currentVariant = () => variants.find((item) => String(item.id) === String(variantInput?.value)) || variants[0];
      const currentUnitPrice = () => {
        const variant = currentVariant();
        if (!variant) return 0;
        if (purchaseMode !== 'subscription' || !planSelect) return variant.price;
        return variant.selling_plan_allocations?.find((item) => String(item.selling_plan_id) === String(planSelect.value))?.price || variant.price;
      };
      const syncFormState = () => {
        const variant = currentVariant();
        if (variantInput && variant) variantInput.value = String(variant.id);
        if (quantityInput) quantityInput.value = String(quantity);
        if (planInput) planInput.value = purchaseMode === 'subscription' && planSelect ? planSelect.value : '';
      };
      const refreshPrices = () => {
        const variant = currentVariant();
        if (!variant) return;
        const unitPrice = currentUnitPrice();
        root.querySelectorAll('[data-tier-price]').forEach((node) => {
          node.textContent = money(unitPrice * Number(node.dataset.tierPrice));
        });
        if (mobilePrice) mobilePrice.textContent = money(unitPrice * quantity);
        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? addLabel.dataset.available || addLabel.textContent : addLabel.dataset.soldOut || 'Sold out';
        syncFormState();
      };
      root.querySelectorAll('[data-quantity]').forEach((button) => button.addEventListener('click', () => {
        quantity = Number(button.dataset.quantity);
        if (quantityInput) quantityInput.value = String(quantity);
        root.querySelectorAll('[data-quantity]').forEach((item) => item.classList.toggle('is-active', item === button));
        refreshPrices();
      }));
      variantSelect?.addEventListener('change', () => {
        if (variantInput) variantInput.value = variantSelect.value;
        refreshPrices();
      });

      const planInput = root.querySelector('[data-selling-plan-input]');
      const planSelect = root.querySelector('[data-selling-plan-select]');
      const planWrap = root.querySelector('[data-selling-plan-wrap]');
      const modes = root.querySelectorAll('[data-purchase-mode]');
      const setMode = (mode) => {
        purchaseMode = mode;
        modes.forEach((button) => button.classList.toggle('is-active', button.dataset.purchaseMode === mode));
        const subscribing = mode === 'subscription';
        if (planWrap) planWrap.hidden = !subscribing;
        refreshPrices();
      };
      modes.forEach((button) => button.addEventListener('click', () => setMode(button.dataset.purchaseMode)));
      planSelect?.addEventListener('change', () => {
        refreshPrices();
      });
      if (form) {
        form.addEventListener('submit', syncFormState, true);
        const cleanAppWidget = () => {
          form.querySelectorAll('.appstle_sub_widget').forEach((widget) => widget.remove());
          syncFormState();
        };
        new MutationObserver(cleanAppWidget).observe(form, { childList: true, subtree: true });
        window.setTimeout(cleanAppWidget, 0);
        window.setTimeout(cleanAppWidget, 500);
      }
      if (planSelect) setMode('subscription');
      else refreshPrices();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
